import { Separator as SeparatorPrimitive } from '@base-ui/react/separator';

import { cn } from '@/lib/utils';

const horizontalSizeClasses = {
  xsmall: '',
  small: 'my-2',
  medium: 'my-4',
  large: 'my-6',
} as const;

const verticalSizeClasses = {
  xsmall: 'h-[0.9em]',
  small: 'h-[1.2em]',
  medium: 'h-[1.6em]',
  large: 'h-[2em]',
} as const;

type Props = {
  className?: string;
  color?: 'gray' | 'black';
  size?: 'xsmall' | 'small' | 'medium' | 'large';
  orientation?: 'horizontal' | 'vertical';
};

const borderColorClasses = {
  gray: 'bg-gray-200',
  black: 'bg-gray-800',
} as const;

const baseClasses =
  'shrink-0 data-horizontal:h-px data-horizontal:w-full data-vertical:w-px data-vertical:self-center';

const Separator = ({
  className,
  color = 'gray',
  size = 'medium',
  orientation = 'horizontal',
  ...rest
}: Props) => {
  const separatorClasses = cn(
    baseClasses,
    borderColorClasses[color],
    orientation === 'horizontal' ? horizontalSizeClasses[size] : verticalSizeClasses[size],
  );

  return (
    <SeparatorPrimitive
      data-orientation={orientation}
      data-slot="separator"
      orientation={orientation}
      className={cn(separatorClasses, className)}
      {...rest}
    />
  );
};

export default Separator;
